import React from 'react';
import { List } from 'antd-mobile';
import { isLessThanAnHour, isLiveInProgress, extract, isLiveEnded } from '../../../../../../../../helpers';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Icon } from 'react-onsenui';

const BtnPushingLiveScorePage = props => {
    const text = !isLessThanAnHour(props.date) ? 'Ton live sera disponible 1h avant le match' : (isLiveInProgress(props.live) ? 'Continue ton live' : (isLiveEnded(props.live) ? 'Le live est terminé' : 'Commence ton live'));
    const id = props.live.id || extract(props.live['@id'], '/', 3);
    return (
        <List>
            <List.Item
                arrow='horizontal'
                thumb={<div style={{color: '#004586'}}><Icon size={18} icon='md-eye' /></div>}
                onClick={() => props.history.push(`/live/${id}`)}
            ><div className='common' style={{fontWeight: '700'}}>{text}</div></List.Item>
        </List>
    )
}

BtnPushingLiveScorePage.propTypes = {
    date: PropTypes.string.isRequired,
    live: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
}

export default withRouter(BtnPushingLiveScorePage);